// cultureMixin.js
export const cultureMixin = {
    methods: {
        GetCulture() {
            if (this.culture == "dk") {
                return "da-dk";
            } else {
                return "en-us";
            }
        },
    }
};